module.exports = __webpack_public_path__ + "static/media/truck_grey.75950c12.png";